import { useMutation, useQueryClient } from '@tanstack/react-query';
import updateSRTService from 'API/SRT/updateSRTService';

/**
 * Updates the company's SRT service.
 *
 * @returns TanStack mutation taking the service payload.
 */
const useUpdateSRTService = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (params) => updateSRTService(params),
        onSuccess: (_data, { id }) => {
            queryClient.invalidateQueries({ queryKey: ['srtService', id] });
            queryClient.invalidateQueries({ queryKey: ['dashboardServices'] });
        },
    });
};

export default useUpdateSRTService;
